<template>
  <div id="app">
    <!-- 路由出口 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
    }
  },
  created() {

  }
}
</script>

<style>
/* 仅供屏幕阅读器读取的文本，不改变视觉呈现。
   用于「纯图/纯组件」页面补语义标题，属于无障碍写法，不做关键词堆砌。 */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>